import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    selectBtn: (allSelected: boolean): string =>
      translate({ id: allSelected ? 'global.deselectAll' : 'global.selectAll' }),
    noEntries: {
      title: translate({ id: 'simulations.list.noEntries.title' }),
      description: translate({ id: 'simulations.list.noEntries.description' }),
      action: translate({ id: 'simulations.list.noEntries.action' }),
    },
    noResults: {
      title: translate({ id: 'simulations.list.noResults.title' }),
      description: translate({ id: 'simulations.list.noResults.description' }),
    },
    addSimulation: translate({ id: 'simulations.addSimulation' }),
  }))

  return api
}
